import { tablet } from "components/templates/Breakpoints";
import { FC, PropsWithChildren } from "react";
import styled from "styled-components";
import { color } from "../../styles";

export type CheckListItemProps = PropsWithChildren<{
  title?: string;
  compact?: boolean;
}>;

export const CheckListItem: FC<CheckListItemProps> = ({ title, compact = false, children }) => (
  <TextWrap compact={compact}>
    <ImageContainer>
      <Img src="/static/icons/Check.svg" alt="tick" />
    </ImageContainer>
    <Div>
      {title && <Title>{title}</Title>}
      {children}
    </Div>
  </TextWrap>
);

const TextWrap = styled.li<{ compact?: boolean }>`
  display: flex;
  gap: 1rem;
  ${(p) =>
    p.compact
      ? `
      letter-spacing: 0.029rem;
      margin: 0.3rem 1rem 1.2rem 0.3rem;
`
      : null}

  ${tablet} {
    font-size: 1.125rem;
  }
`;

const ImageContainer = styled.div`
  height: 1.5rem;
  width: 1.5rem;
`;

const Img = styled.img`
  height: 1.5rem;
  width: 1.5rem;
  margin-top: 0.125rem;
`;

const Div = styled.div`
  max-width: 30rem;
`;

const Title = styled.strong`
  font-size: 1.25rem;
  line-height: 2rem;
  color: ${color.B1100};
`;
